import {apiGet, apiPost} from "../../shared/api/client";
import {mapApiError} from "../../shared/api/errors";

const MAX_MESSAGE_LENGTH = 500;

export const partnerBotQueryKeys = {
    company: (placeId) => ["admin-partner-bot-company", String(placeId)],
    invites: (companyId) => ["admin-partner-bot-invites", String(companyId)],
};

// Карточка заведения живет на legacy place id, а инвайты партнёрского бота —
// на канонической компании. Резолвер переводит одно в другое.
export const resolveBotCompany = async (placeId) =>
    apiGet(`/api/v2/admin/partner-bot/companies/by-place/${placeId}`);

export const listBotInvites = async (companyId) =>
    apiGet("/api/v2/admin/partner-bot/invites", {params: {company_id: companyId}});

export const createBotInvite = async ({companyId, role, expiresInMinutes, reason}) =>
    apiPost("/api/v2/admin/partner-bot/invites", {
        company_id: companyId,
        role,
        expires_in_minutes: expiresInMinutes,
        reason,
    });

export const revokeBotInvite = async ({inviteId, reason}) =>
    apiPost(`/api/v2/admin/partner-bot/invites/${inviteId}/revoke`, {reason});

// Бэкенд партнёрского бота отдает человекочитаемый message на 403/409/503
// («Partner Telegram bot не настроен» и т.п.) — показываем его вместо
// общего текста mapApiError.
export const mapPartnerBotApiError = (error) => {
    const backendMessage = error?.response?.data?.message;
    const mapped = mapApiError(error);
    if (typeof backendMessage !== "string" || !backendMessage.trim()) return mapped;
    return {...mapped, message: backendMessage.trim().slice(0, MAX_MESSAGE_LENGTH)};
};
